import type { HTMLAttributes, MouseEventHandler } from 'react';

export interface CardItemProSmallData {
  image?: string;
  title?: string;
  subtitle?: string;
  onClick?: MouseEventHandler;
  loading?: boolean;
}

export interface CardItemProSmallProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick' | 'title'>,
    CardItemProSmallData {}
